export const KeyCommand = {
    OPEN_MENTION_CONTEXT_MENU: 'OPEN_MENTION_CONTEXT_MENU',
    CARRIAGE_RETURN: 'CARRIAGE_RETURN',
}
